module.exports = __webpack_public_path__ + "media/images/testimonial_photo-1dbd012278678256397b36780dbf4528778d6d41df5d8e967642fc9a132e150f.jpg";